import { Link } from 'react-router-dom';
import { ShieldMark } from '../components/ShieldMark';

interface Props {
  kind: 'resident' | 'provider' | 'hire';
}

const COPY: Record<Props['kind'], { heading: React.ReactNode; body: string }> = {
  resident: {
    heading: <>Application <em>received.</em></>,
    body: 'Thank you. We will review your application within 5 business days and contact you by phone to confirm next steps. If your situation is urgent, please let us know.',
  },
  provider: {
    heading: <>Welcome to the <em>network.</em></>,
    body: 'Thank you for joining as a founding Mowkin. We will reach out within 3 business days to confirm your details, request your insurance certificate, and onboard you to the lead routing system.',
  },
  hire: {
    heading: <>Request <em>routed.</em></>,
    body: 'Thank you. Your request is heading to one of our Mowkin providers in the Coastal Bend. A Mowkin will contact you within 2 business days to schedule and quote. Your hire helps keep our free-mow program alive for neighbors who need it.',
  },
};

export function ThankYouPage({ kind }: Props) {
  const { heading, body } = COPY[kind];
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-24 text-center">
      <div className="text-terracotta mb-8 flex justify-center">
        <ShieldMark size={80} />
      </div>
      <h1
        className="text-5xl text-forest mb-6 leading-tight font-display"
        style={{ fontVariationSettings: '"opsz" 144' }}
      >
        {heading}
      </h1>
      <p className="text-lg text-forest/75 mb-10 leading-relaxed">{body}</p>
      <Link
        to="/"
        className="border-2 border-forest text-forest px-8 py-3 text-sm tracking-[0.1em] uppercase hover:bg-forest hover:text-cream transition-colors"
      >
        ← Back to home
      </Link>
    </div>
  );
}
